module.exports = __webpack_public_path__ + "static/img/endless_mode_photo.efb3e04.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/endless_mode/endless_mode_photo.png
// module id = TuE+
// module chunks = 1